import React, { useContext, useEffect, useState } from "react";
import BankImg from "../../assets/img/fluent_shield.svg";
import Checkicon from "../../assets/img/check-list.svg";
import notIcon from "../../assets/img/noticIcon.svg";
import useTranslator from "../../hooks/useTranslator";
import AuthContext from "../../context/auth/AuthContext";
import { haveValue } from "../../helper/common";
import { toast } from "../../helper/common";
import TenantContext from "../../context/tenant/TenantContext";

function ConnectBankCard(props) {
  const {
    setBankshow,
    paymentScoreLoading,
    setReconnectFlow,
    financial_info_errors,
    isGuarantor,
  } = props;

  const context = useContext(AuthContext);

  const user = props.user || context.user;

  const { _t } = useTranslator();
  const { loadUserTenant } = useContext(AuthContext);
  const { sendRemoteConnectLink } = useContext(TenantContext);
  const [sendLinkLoading, setSendLinkLoading] = useState(false);

  useEffect(() => {
    let intervalId;

    const checkAndLoad = () => {
      if (user?.bank_status === true && !haveValue(user?.paymentScores)) {
        loadUserTenant("tenant");
      } else {
        clearInterval(intervalId);
      }
    };

    checkAndLoad();
  }, []);

  const benefits = [
    _t(
      "createYourScore",
      "Benefit section in new tenant side to promote connection of bank account"
    ),
    _t(
      "fasterApprovalsFromLandlords",
      "Benefit section in new tenant side to promote connection of bank account"
    ),
    _t(
      "boostYourProfile",
      "Benefit section in new tenant side to promote connection of bank account"
    ),
    _t(
      "speedUpRenting",
      "Benefit section in new tenant side to promote connection of bank account"
    ),
    _t(
      "boostFinancials",
      "Benefit section in new tenant side to promote connection of bank account"
    ),
  ];

  const handleInitiateTink = () => {
    setBankshow(true);
    setReconnectFlow(true);
  };

  const sendRemoteConnectToBank = async () => {
    setSendLinkLoading(true);

    try {
      const payload = {
        guarantor_id: user?._id,
      };
      const response = await sendRemoteConnectLink(payload);
      if (response?.success) {
        toast.success(_t("remainderSentSuccessfully"));
      }
    } catch (error) {
      console.log("Error", error);
      toast.error(_t("errorSendingTinkLink"));
    } finally {
      setSendLinkLoading(false);
    }
  };

  return (
    <div className="conact-back-info h-100">
      <div className="bank-conact-wrapper">
        <div className="d-flex flex-column">
          <div className="d-flex justify-content-between align-items-start gap-4">
            <div>
              <h4
                className={`mb-0 ${
                  haveValue(financial_info_errors) ||
                  haveValue(user?.financial_info_errors)
                    ? "failedKycWrapper"
                    : ""
                }`}
              >
                {haveValue(financial_info_errors) ||
                haveValue(user?.financial_info_errors) ? (
                  <img src={notIcon} className="notIcon" />
                ) : (
                  (paymentScoreLoading || user?.bank_status == true) &&
                  !haveValue(user?.paymentScores) && (
                    <img
                      src="/gif/loading-gif.mov.gif"
                      className="loadingGif"
                    />
                  )
                )}
                {haveValue(financial_info_errors) ||
                haveValue(user?.financial_info_errors)
                  ? `${_t(
                      "failedToVerifyFinancials",
                      "Financial Skor error from algoan and tink"
                    )}`
                  : (paymentScoreLoading || user?.bank_status == true) &&
                      !haveValue(user?.paymentScores)
                    ? `${_t(
                        "yourSkorIsBeingGenerated",
                        "New tenant side screen connect bank component"
                      )}...`
                    : _t(
                        isGuarantor
                          ? "financialInformationNotYetVerified"
                          : "verifyYourFinancialInformation",
                        "New tenant side screen connect bank component"
                      )}
              </h4>
            </div>
            <div className="Securedbtn d-flex justify-content-between align-items-center gap-2 hideOnMobile">
              <img src={BankImg} alt="img" />
              <span className="">
                {_t("secured", "New tenant side screen connect bank component")}
              </span>
            </div>
          </div>
          {!(
            haveValue(financial_info_errors) ||
            haveValue(user?.financial_info_errors)
          ) && (
            <p>
              {_t(
                "toBuildAStrongProfileConnectYourBankWithSkorNowItWillHelpYou",
                "New tenant side screen connect bank component"
              )}
            </p>
          )}
          <div className="Securedbtn d-flex justify-content-between align-items-center gap-2 hideOnDesktop">
            <img src={BankImg} alt="img" />
            <span className="">
              {_t("secured", "New tenant side screen connect bank component")}
            </span>
          </div>
          {haveValue(financial_info_errors) ||
          haveValue(user?.financial_info_errors) ? (
            <span className="failedKycError">
              {_t(user?.financial_info_errors, "Tink and Algoan Error")}
            </span>
          ) : (
            <ul>
              {benefits.map((benefit, index) => (
                <h6 key={index}>
                  <img src={Checkicon} alt="icon" />
                  <li>{benefit}</li>
                </h6>
              ))}
            </ul>
          )}
        </div>
        <div className="d-flex justify-content-between align-items-center custom-gap-2">
          {!paymentScoreLoading &&
            user?.bank_status === false &&
            !(
              haveValue(user?.financial_info_errors) ||
              haveValue(financial_info_errors)
            ) &&
            (isGuarantor ? (
              <button
                className="btnNext"
                disabled={sendLinkLoading}
                onClick={sendRemoteConnectToBank}
              >
                {sendLinkLoading ? _t("sendingLink") : _t("sendRemainder")}
                <img src="/images/arrow-right.svg" />
              </button>
            ) : (
              <button onClick={handleInitiateTink}>
                {_t(
                  "verifyNow",
                  "New tenant side screen connect bank component"
                )}
                <img src="/images/arrow-right.svg" />
              </button>
            ))}
          {(haveValue(financial_info_errors) ||
            haveValue(user?.financial_info_errors)) && (
            <button onClick={handleInitiateTink}>
              {_t(
                "reVerifyFinancials",
                "New tenant side screen connect bank component"
              )}
              <img src="/images/arrow-right.svg" />
            </button>
          )}
          <div className="bankIconWrapper d-flex justify-content-center align-items-center">
            <img src="/images/bank-icon.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConnectBankCard;
